import { View } from '@play-co/timestep-core/ui';
import BaseTeamPage from './BaseTeamPage';
import TeamInputField from './TeamInputField';
import ButtonScaleViewWithText from 'src/lib/ui/components/ButtonScaleViewWithText';
import uiConfig from 'src/lib/ui/config';
import sounds from 'src/lib/sounds';
import { Feature } from 'src/replicant/analytics';
import { AsyncScroll } from 'src/game/components/shared/AsyncScroll';
import { TeamExtendedProfile } from 'src/replicant/team/team.schema';
import { TeamEntry } from './TeamEntry';
import StateObserver from 'src/StateObserver';
import i18n from 'src/lib/i18n/i18n';

const ui = uiConfig.buruburu.care.confirmation;

export default class TeamSearchPage extends BaseTeamPage {
  private scroll!: AsyncScroll<
    TeamExtendedProfile | { message: string },
    TeamEntry
  >;

  constructor(private superview: View) {
    super(superview);
    this.addContent();
    this.addHeader();
  }

  private addHeader() {
    const width = 497;

    const searchBtn = new ButtonScaleViewWithText({
      ...ui.okButton,
      width: 132,
      height: 75,
      x: width + 62,
      y: this.header.style.height * 0.5 - 75 * 0.5,
      superview: this.header,
      icon: {
        image: 'assets/ui/match2/team/icon_search.png',
        width: 52,
        height: 53,
      },
      onClick: async () => {
        sounds.sfx.play('ok');
        await this.scroll.setDataProvider(
          async () => {
            const members =
              await StateObserver.replicant.asyncGetters.searchTeams({
                query: inputfield.text,
              });

            if (!members.length) {
              return [{ message: i18n('match2.team.no_results') }];
            }
            return members;
          },
          {
            feature: Feature.TEAM._,
            subFeature: Feature.TEAM.SEARCH_TEAMS,
          },
        );
      },
      tracking: {
        feature: Feature.MATCH2.TEAM._,
        $subFeature: Feature.MATCH2.TEAM.TAB_SEARCH_CTA,
      },
    });

    const inputfield = new TeamInputField({
      superview: this.header,
      width,
      x: width * 0.5 + 31,
      y: this.header.style.height * 0.5,
      placeholder: 'match2.team.create_placeholder3',
      centerOnOrigin: true,
      allowClear: true,
      minLength: 3,
      maxLength: 20,
      onChange: (valid) => {
        searchBtn.setDisabled(!valid);
      },
    });

    inputfield.inputField.attachToPopup('popupTeam');
  }

  private addContent() {
    this.scroll = new AsyncScroll({
      superview: this,
      rect: {
        x: 0,
        y: this.header.style.height,
        width: this.superview.style.width,
        height: this.superview.style.height - this.header.style.height,
      },
      createItem: (superview, _, data) => {
        const entry = new TeamEntry({ superview });
        entry.on('Close', () => {
          this.emit('Close');
        });
        if ('loading' in data) {
          data = { message: i18n('match2.team.loading') };
        }
        entry.style.x = (superview.style.width - entry.style.width) * 0.5;
        entry.setup(data);
        return entry;
      },
      recycle: true,
      setData: (_, data, view) => {
        if ('loading' in data) {
          data = { message: i18n('match2.team.loading') };
        }
        view.setup(data);
      },
    });
  }
}
